export const ADMIN = 'ROLE_ADMIN';
export const USER = 'ROLE_USER';
export const MANAGER = 'ROLE_MANAGER';
